// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "电子CAD",
        "tec": "侯欣明",
        "week": "1,3,5,7,9,11周",
        "add": "实训楼F座202自控"
      },
      {
        "sub": "电子CAD",
        "tec": "包妍",
        "week": "2,4,6,8,10周",
        "add": "实训楼F座202自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "包妍",
        "week": "14周",
        "add": "实训楼F座102自控"
      }
    ],
    [
      {
        "sub": "数字电子技术基础",
        "tec": "孟祥斌",
        "week": "1-12周",
        "add": "实训楼F座102自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "包妍",
        "week": "14周",
        "add": "实训楼F座103自控"
      }
    ],
    {
      "sub": "单片机原理",
      "tec": "田景贺",
      "week": "5-12周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "国家安全教育",
      "tec": "周彩虹",
      "week": "9-12周",
      "add": "教学楼A座225电力"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "周彩虹",
        "week": "1-5,7-9周",
        "add": "教学楼A座222电力"
      },
      {
        "sub": "劳动与创造",
        "tec": "包妍",
        "week": "14周",
        "add": "实训楼F座202自控"
      }
    ],
    [
      {
        "sub": "高频电子线路",
        "tec": "郎东革",
        "week": "1,3,5,7,9,11周",
        "add": "教学楼A座220电力"
      },
      {
        "sub": "高频电子线路",
        "tec": "郎东革",
        "week": "2,4,6,8,10周",
        "add": "教学楼A座220电力"
      },
      {
        "sub": "劳动与创造",
        "tec": "包妍",
        "week": "14周",
        "add": "实训楼F座202自控"
      }
    ],
    {
      "sub": "传感器原理与应用",
      "tec": "包妍刘慧洁",
      "week": "1-12周",
      "add": "实训楼F座202自控"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "数字电子技术基础",
      "tec": "孟祥斌",
      "week": "1-12周",
      "add": "实训楼F座101自控"
    },
    {
      "sub": "单片机原理",
      "tec": "田景贺",
      "week": "1-12周",
      "add": "实训楼F座202自控"
    },
    0,
    0,
    {
      "sub": "就业创业指导",
      "tec": "邓苏栩包妍",
      "week": "1-5周",
      "add": "教学楼C座110教务"
    }
  ],
  "4": [
    {
      "sub": "高频电子线路",
      "tec": "郎东革",
      "week": "1,3,5,7,9周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "传感器原理与应用",
      "tec": "包妍刘慧洁",
      "week": "1-12周",
      "add": "实训楼F座301信息"
    },
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "周彩虹",
      "week": "1-5,7-9周",
      "add": "教学楼A座326电力"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "单片机原理",
      "tec": "田景贺",
      "week": "1-12周",
      "add": "实训楼F座202自控"
    },
    {
      "sub": "电子CAD",
      "tec": "包妍",
      "week": "2,4,6,8,10周",
      "add": "实训楼F座202自控"
    },
    {
      "sub": "国家安全教育",
      "tec": "周彩虹",
      "week": "9-12周",
      "add": "实训楼F座103自控"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
